export const OLD_PUBLIC_ROUTES_MAP = {
  legal: '/legal/:name',
};
